import type { OutputCustomQuestion } from '../../graphql/generated/graphql';

export type CompleteCustomQuestionResponse = {
  position: number;
  id: string;
  question: OutputCustomQuestion;
  status: 'complete';
};

export type IllegalCustomQuestionResponse = {
  position: number;
  location: string;
  reason: string;
  status: 'illegal';
};

export type CustomQuestionApiErrorResponse = {
  position: number;
  reason: string;
  status: 'apiError';
};

export type CustomQuestionResponse =
  | CompleteCustomQuestionResponse
  | IllegalCustomQuestionResponse
  | CustomQuestionApiErrorResponse;

export function isCompleteCustomQuestion(
  response: CustomQuestionResponse,
): response is CompleteCustomQuestionResponse {
  return response.status === 'complete';
}

export function isIllegalCustomQuestion(
  response: CustomQuestionResponse,
): response is IllegalCustomQuestionResponse {
  return response.status === 'illegal';
}

export function isCustomQuestionApiError(
  response: CustomQuestionResponse,
): response is CustomQuestionApiErrorResponse {
  return response.status === 'apiError';
}
